import React from 'react'

import Wrapper from '../../../hoc/Wrapper/Wrapper';
import { IsStringEmpty } from '../../../utilities/CommonMethods';
import Backdrop from '../Backdrop/Backdrop';

import classes from './FlexModal.module.css';

const flexModal = (props) => {
  let styleClasses = [classes.ModalContainer];
  styleClasses.push(props.visible ? classes.ModalOpen : classes.ModalClosed);
  styleClasses.push(props.forZenStatSection ? classes.NegativeTop : null);
  styleClasses.push(props.forSessionPlanForm ? classes.SetMinWidth : null);
  styleClasses.push(props.fixedPosition ? classes.FixedPosition : null);
  // styleClasses.push(props.styleClasses)

  let modalStyleClass = [classes.Modal];
  modalStyleClass.push(props.halfScreen ? classes.HalfScreen : null);
  modalStyleClass.push(props.fullScreenMobile ? classes.FullScreen : null);

  const width = !IsStringEmpty(props.width) ? props.width : "37%";
  const height = !IsStringEmpty(props.height) ? props.height : "auto";
  const maxHeight = !IsStringEmpty(props.maxHeight) ? props.maxHeight : "95vh";

  return (
    <Wrapper>
      <div className={styleClasses.join(' ')}>
        <Backdrop visible={props.visible} backdropClicked={props.backdropClicked} />
        <div className={modalStyleClass.join(' ')} style={{ 'width': width, 'height': height, 'maxHeight': maxHeight }}>
          {props.children}
        </div>
      </div>
    </Wrapper>
  )
}

export default flexModal;